<div class="gb-popper-container">
  <div class="popper-content" (click)="goToItem()">
    <div *ngIf="popperPayload.image" class="popper-image" [ngStyle]="getBackgroundStyle(popperPayload.image)"></div>
    <div class="gb-popper-text">
      <span class="gb-two-line-truncate"> {{ popperPayload.text }} </span>
    </div>
  </div>
  <button (click)="hidePopper()" class="close-button" mat-button>
    <mat-icon>close</mat-icon>
  </button>
</div>
